<template>
    <div class="index-box" style="padding-bottom: 50px;">
        <!-- search  -->
        <div class="search-box">
            <div class="search">
                <router-link to="/search/index">
                    <div class="iconfont icon-sousuo1"></div>
                    <div class="text">搜索你想要的商品</div>
                </router-link>
            </div>
        </div>

        <!-- banner -->
        <div class="banner">
            <nut-swiper
                direction="horizontal"
                :loop="true"
                :canDragging="false"
                :paginationVisible="true"
                :swiperData="bannerList"
                :autoPlay=3000
            >
                <div v-for="(item,index) in bannerList" :key="index" class="nut-swiper-slide">
                    <div @click="toBanner(item.goods_url)">
                        <img :src="item.file_name">
                    </div>
                </div>
            </nut-swiper>
        </div>
        <!-- banner end -->
        <!-- menu  -->
        <div class="menu-list-box">
            <div class="menu-list clearfix">
                <div class="list-item" v-for="(item,index) in menuList" :key="index"
                     v-if="menuList.length && item.isshow && index<=8">
                    <router-link class="item" :to="{path: '/goods/category',query: {category_id:item.category_id}}">
                        <div class="t-icon skeleton-rect">
                            <img v-if="item.image" :src="item.image.file_path"/>
                        </div>
                        <div class="text skeleton-rect">{{ item.name }}</div>
                    </router-link>
                </div>
                <div class="list-item" @click="tomore">
                    <div class="item">
                        <div class="t-icon skeleton-rect">
                            <img src="../../assets/images/hp-icon-10.png"/>
                        </div>
                        <div class="text skeleton-rect">更多</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="spike-box" v-if="spike_goods.length">
            <div class="title-box">
                <span>限时秒杀</span>
                <nut-countdown
                    v-if="spike_goods[0]"
                    :end-time="spike_goods[0].spike_end_time * 1000 "
                    show-days
                >
                </nut-countdown>
            </div>
            <div class="goods-box clearfix">
                <div class="goods-item" v-for="(item,index) in spike_goods">
                    <router-link class="goods-item" :to="{path: '/goods/show',query: {goods_id:item.goods_id}}">
                        <div class="image-box">
                            <img :src="item.goods_image"/>
                        </div>
                        <div class="right-box">
                            <div class="goods_name">{{ item.goods_name }}</div>
                            <div class="sales"> 销量: {{ item.goods_sales }}</div>
                            <div class="bottom-box">
                                <div class="price-box">
                                    <span class="min-price">${{ item.spike_price }}</span>
                                    <span class="line-price">
                                    市场价 <span>${{ item.goods_sku.line_price }}</span>
                                </span>
                                </div>
                                <div class="buy-now">
                                    立即抢购
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="active-box" v-if="category_one.category && category_one.list.total">
            <div class="image-box">
                <img :src="category_one.category.image.file_path"/>
            </div>
            <div class="goods-box">
                <div class="goods-item" v-if="category_one.list" v-for="(item,index) in category_one.list.data"
                     :key="index">
                    <router-link class="item" :to="{path: '/goods/show',query: {goods_id:item.goods_id}}">
                        <div class="image-box">
                            <img :src="item.goods_image" alt="">
                        </div>
                        <div class="goods_name van-multi-ellipsis--l2">{{ item.goods_name }}</div>
                        <div class="bottom-box">
                            <div class="price-box">
                                <div class="min-price">${{ item.goods_min_price }}</div>
                                <div class="line-price">${{ item.goods_sku.line_price }}</div>
                            </div>
                            <div class="car">
                                <span class="iconfont icon-gouwuche"></span>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="tips">
                左滑查看更多商品
            </div>
        </div>

        <div class="new-goods-box" v-if="category_two_category && category_two_list.total">
            <div class="image-box">
                <img :src="category_two_category.image.file_path"/>
            </div>

            <div class="goods-box clearfix">
                <div class="goods-item" v-if="category_two_list" v-for="(item,index) in category_two_list.data"
                     :key="index">
                    <router-link class="item" :to="{path: '/goods/show',query: {goods_id:item.goods_id}}">
                        <div class="goods-image">
                            <img :src="item.goods_image">
                        </div>
                        <div class="goods-name">
                            {{ item.goods_name }}
                        </div>
                        <div class="bottom-box">
                            <div class="price-box">
                                <div class="min-price">${{ item.goods_min_price }}</div>
                                <div class="line-price">${{ item.goods_sku.line_price }}</div>
                            </div>
                            <div class="car">
                                <span class="iconfont icon-gouwuche"></span>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="more-box">
                <button class="more-button" @click="getMoreNewGoods">查看更多<span class="iconfont icon-jiantou1"></span>
                </button>
            </div>

        </div>

        <div class="new-goods-box" v-if="category_three.category && category_three.list.total">
            <div class="image-box">
                <img :src="category_three.category.image.file_path"/>
            </div>
            <div class="goods-box">
                <div>
                    <div class="goods-item" v-if="category_three.list && (index % 2 == 0)"
                         v-for="(item,index) in category_three.list.data" :key="index">
                        <router-link class="item" :to="{path: '/goods/show',query: {goods_id:item.goods_id}}">
                            <div class="image-box">
                                <img :src="item.goods_image" alt="">
                            </div>
                            <div class="goods_name">{{ item.goods_name }}</div>
                            <div class="bottom-box">
                                <div class="price-box">
                                    <div class="min-price">${{ item.goods_min_price }}</div>
                                    <div class="line-price">${{ item.goods_sku.line_price }}</div>
                                </div>
                                <div class="car">
                                    <span class="iconfont icon-gouwuche"></span>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div>
                    <div class="goods-item" v-if="category_three.list && (index % 2 != 0)"
                         v-for="(item,index) in category_three.list.data" :key="index">
                        <router-link class="item" :to="{path: '/goods/show',query: {goods_id:item.goods_id}}">
                            <div class="image-box">
                                <img :src="item.goods_image" alt="">
                            </div>
                            <div class="goods_name van-multi-ellipsis--l2">{{ item.goods_name }}</div>
                            <div class="bottom-box">
                                <div class="price-box">
                                    <div class="min-price">${{ item.goods_min_price }}</div>
                                    <div class="line-price">${{ item.goods_sku.line_price }}</div>
                                </div>
                                <div class="car">
                                    <span class="iconfont icon-gouwuche"></span>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="tips">
                左滑查看更多商品
            </div>
        </div>
        <div class="category-box" v-if="category_list">
            <div class="category-item" :class="1 == category_id ? 'active' : ''" @click="hotGoodsList()">精品推荐</div>
            <div class="category-item" :class="item.category_id == category_id ? 'active' : ''"
                 v-for="(item,index) in category_list" :key="index" v-if="index > 0 && item.isshow == 1"
                 @click="switchCategory(item.category_id)">{{ item.name }}
            </div>
        </div>

        <div class="goods-list-box clearfix" v-if="hot_goods_list">
            <div class="goods-list-item" v-for="(item, index) in hot_goods_list" :key="index">
                <router-link class="item" :to="{path: '/goods/show',query: {goods_id:item.goods_id}}">
                    <div class="goods-image">
                        <img :src="item.goods_image" alt="">
                    </div>
                    <div class="goods-name"> {{ item.goods_name }}</div>
                    <div class="first_row">
                        <div class="sales">已售
                            {{ category_id == 1 ? item.sales_actual + item.sales_initial : item.goods_sales }}
                        </div>
                        <div class="percentage" v-if="item.percentage == 10 && item.percentage_eduction > 0">
                            {{ item.percentage_eduction }}%OFF
                        </div>
                    </div>
                    <div class="sales_initial">{{ item.selling_point ? item.selling_point : '' }}</div>
                    <div class="third_row">
                        <div class="price-box">
                            <span class="min-price">
                                ${{ category_id == 1 ? item.goods_price : item.goods_min_price }}</span>
                            <span class="line-price" v-if="category_id == 1">市场价
                                <span>${{ item.line_price }}</span> </span>
                            <span class="line-price" v-if="category_id != 1 && item.goods_sku">市场价
                                <span>${{ item.goods_sku.line_price }}</span> </span>
                        </div>
                        <div class="car">
                            <span class="iconfont icon-gouwuche"></span>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>

        <div style="height: 200px">

        </div>
        <!-- screen list end -->
        <Tabber ref="updateNum"></Tabber>
    </div>
</template>
<script>
import Tabber from '@/components/Tabber.vue'

export default {
    name: 'index',
    components: {
        Tabber
    },
    data() { //默认数据
        return {
            bannerList: [],
            menuList: [],
            classifyproduct: [],
            hptablist: [],
            coupon: [],
            hpspeciallist: [],
            bannerimgUrls: [],
            category_one: [],
            category_two_category: [],
            category_two_list: [],
            category_three: [],
            category_two_page: 1,
            spike_goods: [],
            category_list: [],
            category_id: 1,
            hot_goods_list: []
        }
    },
    created() {
        let _this = this;
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });
        _this.shippingLocation = _this.$ls.get('shippingLocation') ? _this.$ls.get('shippingLocation') : '请选择自提点';
        _this.currShippingType = _this.$ls.get('currShippingType') ? _this.$ls.get('currShippingType') : 2;
    },
    mounted() {
        let _this = this;
        // 获取商品分类
        _this.getCategory();
        // // 获取 banner
        _this.getBanner();
        // 获取板块一
        _this.getCategoryOne();
        // 获取板块二
        _this.getCategoryTwo();
        // 获取板块二
        _this.getCategoryThree();
        // 获取秒杀商品
        _this.getSpikeGoods();
        // 获取商品分类
        _this.getCategoryList();
        // 获取精品推荐商品
        _this.hotGoodsList();
        // 监听页面滚动
        // window.addEventListener('scroll', _this.windowScroll);
        this._isMobile
    },
    methods: {


        // 获取所有商品分类
        getCategory: function () {
            let _this = this;
            _this._get('category/index', {}, res => {
                _this.menuList = res.data.list;
            })
        },


        // 获取 banner
        getBanner() {
            let _this = this;
            _this._get('wxapp/banner', {}, res => {
                _this.bannerList = res.data.list;
            });
        },

        getCategoryOne() {
            let _this = this
            _this._get('index.goods/lists', {
                category_id: 30
            }, result => {
                _this.setData({
                    category_one: result.data
                })
            })
        },

        getMoreNewGoods() {
            if (this.category_two_list.last_page <= this.category_two_page) {
                this.$toast.fail('没有更多了！');
                return false
            }
            this.category_two_page += 1
            this.getCategoryTwo(true, this.category_two_page)
        },

        getCategoryTwo(isPage, page) {
            let _this = this
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this._get('index.goods/lists', {
                page: page || 1,
                category_id: 49,
                listRows: 6
            }, result => {
                let resList = result.data.list,
                    dataList = _this.category_two_list;
                if (isPage === true) {
                    _this.setData({
                        'category_two_list.data': dataList.data.concat(resList.data),
                    });
                    _this.category_two_list.data = dataList.data.concat(resList.data)
                } else {
                    _this.setData({
                        category_two_list: resList,
                        category_two_category: result.data.category,
                    });
                }
                _this.loading.hide();
            })
        },

        getCategoryThree() {
            let _this = this
            _this._get('index.goods/lists', {
                category_id: 50
            }, result => {
                _this.setData({
                    category_three: result.data
                })
                _this.loading.hide();
            })
        },

        getSpikeGoods() {
            let _this = this
            _this._get('goods/lists', {
                is_spike: 10,
                listRows: 3
            }, result => {
                _this.setData({
                    spike_goods: result.data.list.data
                })
            })
        },

        getCategoryList() {
            let _this = this;
            _this._get('category/index', {}, reslut => {
                _this.setData({
                    category_list: reslut.data.list
                })
            })
        },

        hotGoodsList() {
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            let _this = this
            _this.category_id = 1
            _this._get('index.index/hotGoodsList', {}, result => {
                _this.hot_goods_list = result.data.hotList
                _this.loading.hide();
            })

        },

        switchCategory(category_id) {
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            let _this = this
            _this.category_id = category_id
            _this._get('index.goods/lists', {
                category_id: category_id,
                sortType: 'sales',
                shuffle: 1
            }, result => {
                _this.hot_goods_list = result.data.list.data
                _this.loading.hide();
            })

        },


        /**
         * 切换下方分类标签
         */
        setGoodsList: function (catid) {
            let _this = this;
            _this.goodsCategoryId = catid
            _this.goodsList = [];
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            // 重新获取商品列表
            _this.getGoodsList();

        },


        /**
         *  添加购物车
         */
        addCart: function (id) {
            let _this = this;
            _this._post_form('cart/add', {
                goods_id: id,
                goods_num: 1,
                goods_sku_id: 0,
            }, result => {
                _this.$toast.success(result.msg);
                // 更新 Tabbar 组件中购物车数量
                _this.$nextTick(() => {
                    _this.$refs.updateNum.update(result.data.cart_total_num);
                });
            })
        },

        // 去更多分类
        tomore() {
            this.navigationTo('/goods/category')
        },

        /**
         *  触底加载
         */
        onInfinite: function () {
            if (this.current_page >= this.last_page) {
                this.isLoading = false;
                this.isHasMore = false;
                return false;
            }
            this.isLoading = true;
            this.isHasMore = true;
            this.getGoodsList(this.current_page + 1);
        },

    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
        // window.removeEventListener('scroll', this.windowScroll);
    }
}
</script>
<style lang="scss">
.index-box {
    background: #f7f7f7;
    position: relative;
    z-index: 1;

    &::after {
        content: "";
        height: 200px;
        //background: #ff5656;
        border-radius: 0 0 250px 250px;
        position: absolute;
        top: 0;
        left: -75px;
        right: -75px;
        z-index: -1;
    }

    .nut-swiper .nut-swiper-pagination .swiper-pagination-bullet.active {
        background: $main-color;
    }

    .countdown-box {
        float: left;

        span {
            float: left;
            color: $main-color;
            font-weight: bold;
        }

        .nut-cd-block {
            height: 24px;
            padding: 0 4px;
            background: $main-color;
            color: #fff;
            margin: 0 4px;
            border-radius: 4px;
        }
    }

    .nut-cd-timer {
        display: flex;
        align-items: center;
        justify-content: center;

        .nut-cd-block {
            display: block;
            font-size: 12px;
            width: 22px;
            height: 18px;
            background: #ff5656;
            color: #ffffff;
            text-align: center;
            line-height: 18px;
            border-radius: 5px;
            font-weight: 500;

            &:first-child {
                display: none;
            }
        }

        .nut-cd-dot {
            width: 10px;
            height: 10px;
            font-size: 20px;
            color: #ff5656;
            line-height: 10px;
            text-align: center;

            &:nth-child(2) {
                display: none;
            }
        }
    }

}
</style>
<style lang="scss" scoped>
@import "index.scss";
</style>
